import { Communicator, ObjectManager } from '../../../concepts/objects';
import { Physical } from '../../canvas/entities/Physical';
import { ActiveObject, resolve } from '../../Container';
import { NativeVideo } from './NativeVideo';
import { VideoStateAttr } from './VideoAttributes';
import { YouTubeVideo } from './YouTubeVideo';

export class VideoController extends ActiveObject {

    @resolve(Communicator) private comms!: Communicator;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public start = () => {
        // this.comms.recv('ytei', (_client, data) => this.onYouTubeVideoInstruction(data))
    };

    public async playOrStop(id: string) {
        const video = this.objects.get(id, Physical);
        const ntv = video.as(NativeVideo);
        if (ntv) await this.playOrStopNativeVideo(ntv);
        const yte = video.as(YouTubeVideo);
        if (yte) await this.playOrStopYouTubeVideo(yte);
    }

    private async playOrStopNativeVideo(ntv: NativeVideo) {
        const player = await ntv.getPlayer();
        // player.addEventListener('audioprocess', () => console.log('audioprocess'));
        // player.addEventListener('canplay', () => console.log('canplay'));
        // player.addEventListener('canplaythrough', () => console.log('canplaythrough'));
        // player.addEventListener('complete', () => console.log('complete'));
        // player.addEventListener('durationchange', () => console.log('durationchange'));
        // player.addEventListener('emptied', () => console.log('emptied'));
        // player.addEventListener('ended', () => console.log('ended'));
        // player.addEventListener('loadeddata', () => console.log('loadeddata'));
        // player.addEventListener('loadedmetadata', () => console.log('loadedmetadata'));
        // player.addEventListener('pause', () => console.log('pause'));
        // player.addEventListener('play', () => console.log('play'));
        // player.addEventListener('playing', () => console.log('playing'));
        // player.addEventListener('progress', () => console.log('progress'));
        // player.addEventListener('ratechange', () => console.log('ratechange'));
        // player.addEventListener('seeked', () => console.log('seeked'));
        // player.addEventListener('seeking', () => console.log('seeking'));
        // player.addEventListener('stalled', () => console.log('stalled'));
        // player.addEventListener('suspend', () => console.log('suspend'));
        // player.addEventListener('timeupdate', () => console.log('timeupdate'));
        // player.addEventListener('volumechange', () => console.log('volumechange'));
        // player.addEventListener('waiting', () => console.log('waiting'));
        player.removeEventListener('play', this.onNativeVideoPlaying);
        player.addEventListener('play', this.onNativeVideoPlaying);
        player.removeEventListener('pause', this.onNativeVideoStoped);
        player.addEventListener('pause', this.onNativeVideoStoped);
        if (!player.paused) {
            player.pause();
        }
        else {
            player.currentTime = 0;
            player.play();
        }
    }

    private onNativeVideoPlaying = (e: any) => {
        const id = e.target?.dataset?.videoSrc;
        const ntv = this.objects.getMaybe(id, NativeVideo);
        if (ntv.alive) VideoStateAttr.set(ntv, 'playing');
    };

    private onNativeVideoStoped = (e: any) => {
        const id = e.target?.dataset?.videoSrc;
        const ntv = this.objects.getMaybe(id, NativeVideo);
        if (ntv.alive) VideoStateAttr.set(ntv, 'stopped');
    };

    private async playOrStopYouTubeVideo(yte: YouTubeVideo) {
        const player = await yte.getPlayer();
        player.removeEventListener('onStateChange', this.onYouTubeVideoStateChange);
        player.addEventListener('onStateChange', this.onYouTubeVideoStateChange);
        if (player.getPlayerState() === 1) {
            player.stopVideo();
            // this.comms.send('ytei', ['stop', id]);
        }
        else {
            player.playVideo();
            player.setVolume(75);
            // this.comms.send('ytei', ['play', id]);
        }
    }

    private onYouTubeVideoStateChange = ({ target }: YT.PlayerEvent) => {
        const id = target.getIframe()?.dataset?.videoSrc;
        const yte = this.objects.getMaybe(id, YouTubeVideo);
        if (yte?.alive) {
            VideoStateAttr.set(yte, target.getPlayerState() === 1 ? 'playing' : 'stopped');
        }
        else {
            target.removeEventListener('onStateChange', this.onYouTubeVideoStateChange);
        }
    };

    // private onYouTubeVideoInstruction = async ([action, id]: [string, string]) => {
    //     console.log(action, id);
    //     const yte = this.objects.get(id, YouTubeVideo);
    //     const player = await yte.getPlayer();
    //     if (action === 'stop') {
    //         player.stopVideo();
    //     }
    //     else {
    //         player.playVideo();
    //         player.setVolume(75);
    //     }
    // }
}
